(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-static/assets/javascripts/button-bet.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-static/assets/javascripts/button-bet.js');
"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  useRef,
  useEffect
} = React;
const {
  ReactButtonBet: UiButtonBet
} = svs.ui;
const {
  wagerSystemTypes
} = svs.components.tipsen.engine.constants;
const betTypeToShowDistribution = [wagerSystemTypes.OWNROWS, wagerSystemTypes.REDUCERA_FRITT, wagerSystemTypes.ENKELRADER];
const ButtonBet = _ref => {
  let {
    result,
    branding,
    isCorrect,
    uSign,
    isSelected,
    distribution,
    betProperties = []
  } = _ref;
  const buttonRef = useRef();
  const classNames = ['pg_coupon_static__bet_btn'];
  let isDistribution = false;
  isCorrect && classNames.push('btn-bet-result');
  const additionalProps = {};
  if (betProperties.length > 0 && distribution && betTypeToShowDistribution.includes(betProperties[0])) {
    additionalProps.title = "Systemf\xF6rdelning ".concat(distribution, "%");
    additionalProps['data-outcome'] = result.resultText.text;
    classNames.push('pg_coupon_static__bet_btn--is-distribution');
    distribution < 50 && classNames.push('pg_coupon_static__bet_btn--is-low-distribution');
    isDistribution = true;
  }
  useEffect(() => {
    if (isDistribution) {
      buttonRef.current.style.setProperty('--distribution', "".concat(distribution, "%"));
    }
  }, [isDistribution, distribution]);
  return React.createElement(UiButtonBet, _extends({
    branding: branding,
    className: classNames.join(' '),
    key: result.resultText.text,
    label: result.resultText.text,
    ref: buttonRef,
    selected: isSelected,
    size: "100"
  }, uSign ? {
    system: 'U'
  } : {}, additionalProps));
};
setGlobal('svs.components.tipsen.couponStatic.ButtonBet', ButtonBet);

 })(window);